<template>
    <v-container>
      <v-card>
        <v-card-title>Customer List</v-card-title>
        <v-row>
            <v-col cols="12" class="d-flex justify-end">
        <v-text-field
          v-model="search"
          hide-details
          prepend-icon="mdi-magnify"
          outlined
          dense
          label="Search"
          solo
          class="small-search"
        />
      </v-col>
    </v-row>
        <v-data-table :headers="headers" :items="customers" class="elevation-1" :items-per-page="5" :search="search">
          <template v-slot:actions="{ item }">
            <v-icon small @click="editCustomer(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteCustomer(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        search: '',
        headers: [
          { text: "Name", value: "name" },
          { text: "Email", value: "email" },
          { text: "Phone", value: "phone" },
          { text: "Address", value: "address" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        customers: [
          { name: "Hassanayn Kashmal", email: "hassa9kashmal@gmail.com", phone: "068-911-8095", address: "123 Kinondoni Studio" },
          { name: "Salim Ally", email: "salimally@gmail.com", phone: "076-000-7760", address: "122 Kimara" },
          { name: "Juma Sule", email: "jsule@gmail.com", phone: "076-456-7900", address: "126 Kariakoo" },
          { name: "John Doe", email: "john@gmail.com", phone: "076-456-7760", address: "163 Posta" },
          { name: "Happy Michael", email: "happy67michael@gmail.com", phone: "076-456-9860", address: "127 Mbagala" },
          { name: "Jane ", email: "jane@gmail.com", phone: "067-654-8720", address: "456 Magomeni" },
          { name: "Tasniim Hussein", email: "tasniim@gmail.com", phone: "077-604-8920", address: "490 Mwanamboka" },
          { name: "Zaifa Haroun", email: "zaifa@gmail.com", phone: "062-654-5620", address: "005 Mbezi" },
          { name: "Nurdeen Yousuph", email: "nurdeen@gmail.com", phone: "078-664-8740", address: "914 Tabata" },
          { name: "Nasser Mohammed", email: "Nasseer@gmail.com", phone: "071-650-0920", address: "891 Masaki" },
        ],
      };
    },
    methods: {
      editCustomer(customer) {
        alert(`Editing customer: ${customer.name}`);
      },
      deleteCustomer(customer) {
        alert(`Deleting customer: ${customer.name}`);
      },
    },
  };
  </script>
  
  <style scoped>
  .small-search {
  max-width: 200px; /* Adjust the width of the search field */
  font-size: 0.8rem;
  }
  </style>
  